// extracted by mini-css-extract-plugin
module.exports = {"formCol":"formCol__sSH43"};